import { ComponentPropsWithoutRef, ComponentPropsWithRef } from 'react'
import clsx from 'clsx'

import { SectionContainer } from '../landings/styles'

import styles from './styles.module.scss'

type SectionPadding = 'small' | 'medium' | 'large' | 'xlarge' | 'none'

type SectionWithPaddingProps = ComponentPropsWithoutRef<
  typeof SectionContainer
> & {
  $sizeTop?: SectionPadding
  $sizeBottom?: SectionPadding
  $sizeMobileTop?: SectionPadding
  $sizeMobileBottom?: SectionPadding
}

export const SectionWithPadding = ({
  $sizeTop = 'small',
  $sizeBottom = 'small',
  $sizeMobileTop,
  $sizeMobileBottom,
  className,
  ...props
}: SectionWithPaddingProps) => (
  <SectionContainer
    className={clsx(
      styles[`top-${$sizeTop}`],
      styles[`bottom-${$sizeBottom}`],
      styles[`topMobile-${$sizeMobileTop || $sizeTop}`],
      styles[`bottomMobile-${$sizeMobileBottom || $sizeBottom}`],
      className
    )}
    {...props}
  />
)

export const SesctionContainer = ({
  className,
  ...props
}: ComponentPropsWithRef<'div'>) => (
  <div className={clsx(styles.container, className)} {...props} />
)

export const SectionCenterHeader = ({
  className,
  ...props
}: ComponentPropsWithRef<'h2'>) => (
  <h2 className={clsx(styles.centerHeader, className)} {...props} />
)

export const StyledCustomPortableText = ({
  className,
  ...props
}: ComponentPropsWithRef<'div'>) => (
  <div className={clsx(styles.portableText, className)} {...props} />
)
